// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ObjectStylePanel_buttonGroup__2OsnG","division_line":"ObjectStylePanel_division_line__3Tmw5"};